import { useEffect, useState } from "react";

interface UseCountdownOptions {
  deadline?: string | null;
  isExpired?: boolean;
  updateInterval?: number; // in milliseconds
}

export function useCountdown(options: UseCountdownOptions = {}) {
  const { deadline, isExpired = false, updateInterval = 60000 } = options;
  const [countdown, setCountdown] = useState<string>("");

  useEffect(() => {
    if (!deadline || isExpired) {
      setCountdown("");
      return;
    }

    const update = () => {
      const now = new Date();
      const deadlineDate = new Date(deadline);
      const diffMs = deadlineDate.getTime() - now.getTime();

      if (diffMs <= 0) {
        setCountdown("");
        return;
      }

      const totalMinutes = Math.floor(diffMs / 60000);
      const days = Math.floor(totalMinutes / (60 * 24));
      const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
      const minutes = totalMinutes % 60;

      if (days > 0) {
        setCountdown(`Cierra en ${days}d ${String(hours).padStart(2, '0')}h`);
      } else {
        setCountdown(`Cierra en ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`);
      }
    };

    update();
    const id = setInterval(update, updateInterval);
    return () => clearInterval(id);
  }, [deadline, isExpired, updateInterval]);

  return countdown;
}
